import { useQuery } from "react-query";
import { getAllEmployeesForScoreCard } from "../../../../actions/Employees";

const useGetAllEmployeesForScoreCard = () => {
  return useQuery("GetAllEmployeesForScoreCard", getAllEmployeesForScoreCard, {
    refetchOnWindowFocus: false,
  });
};

export default useGetAllEmployeesForScoreCard;
